<section class="packet-panel">
  <div class="packet-heading"><span class="packet-icon"><mat-icon>timeline</mat-icon></span>
    <div><h2>Scout packet reliability</h2><p>Review packet delivery for a selected date range.</p></div>
  </div>
  <div class="packet-filters">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Date range</mat-label>
      <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
        <input matStartDate [min]="minDate" formControlName="start" placeholder="Start date" (dateChange)="changeEvent($event)">
        <input matEndDate [max]="maxDate" formControlName="end" placeholder="End date" (dateChange)="changeEndEvent($event)">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
      @if (range.controls.start.hasError('matStartDateInvalid')) { <mat-error>Invalid start date</mat-error> }
      @if (range.controls.end.hasError('matEndDateInvalid')) { <mat-error>Invalid end date</mat-error> }
    </mat-form-field>
    @if (scout) {
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Scout</mat-label>
        <mat-select required [(ngModel)]="scout" name="scout" (selectionChange)="scoutSelect($event.value)">
          @for (s of availableScouts; track s) { <mat-option [value]="s">{{ s.assetName }}</mat-option> }
        </mat-select>
      </mat-form-field>
    }
  </div>
  @if (scout) {
    <div class="packet-scout"><button mat-button (click)="navigateToScout(scout)">{{ scout.assetName }}</button>
      <span>{{ scout.customerName }}</span><span>Last payload: {{ lastPayloadDate }}</span></div>
    <div class="packet-metrics">
      <div><span>Expected</span><strong>{{ scout.expectedPacketCount }}</strong></div>
      <div><span>Failed</span><strong>{{ scout.failedPacketCount }}</strong></div>
      <div><span>Successful</span><strong>{{ scout.successfulPacketCount }}</strong></div>
      <div><span>Success rate</span><strong>{{ scout.percentage }}%</strong></div>
    </div>
    <app-health-percentage-bar [total]="scout.totalPacketCount" [successful]="scout.successfulPacketCount"
      [failed]="scout.failedPacketCount"></app-health-percentage-bar>
  } @else {
    <div class="packet-empty"><mat-icon>insert_chart_outlined</mat-icon><h3>Packet report unavailable</h3>
      <p>Scout reliability data is not currently enabled for this page.</p><span>{{ selectedDate }}</span></div>
  }
  <figure id="pie" [hidden]="!scout" aria-label="Scout packet delivery chart"></figure>
</section>
